import { useState } from "react";
import { ProfileIdentitySection } from "./profile/ProfileIdentitySection";
import { ProfileAmenitiesSection } from "./profile/ProfileAmenitiesSection";
import { ProfileVisualAssetsSection } from "./profile/ProfileVisualAssetsSection";
import { ProfileLinksSection } from "./profile/ProfileLinksSection";
import "./ListingsProfileTab.scss";

type ProfileSectionKey = "identity" | "amenities" | "visual-assets" | "links";

const SECTIONS: { key: ProfileSectionKey; label: string }[] = [
  { key: "identity", label: "Identity" },
  { key: "amenities", label: "Amenities" },
  { key: "visual-assets", label: "Visual Assets" },
  { key: "links", label: "Links" },
];

interface Props {
  locationId?: number;
}

export function ListingsProfileTab({ locationId }: Props) {
  const [active, setActive] = useState<ProfileSectionKey>("identity");

  return (
    <div className="listings-profile">
      <aside className="lp-sidenav">
        {SECTIONS.map((s) => (
          <button
            key={s.key}
            type="button"
            className={`lp-sidenav-item${active === s.key ? " active" : ""}`}
            onClick={() => setActive(s.key)}
          >
            {s.label}
          </button>
        ))}
      </aside>

      <div className="lp-content">
        {active === "identity" && <ProfileIdentitySection locationId={locationId} />}
        {active === "amenities" && <ProfileAmenitiesSection locationId={locationId} />}
        {active === "visual-assets" && <ProfileVisualAssetsSection />}
        {active === "links" && <ProfileLinksSection locationId={locationId} />}
      </div>
    </div>
  );
}
